import { IValueInputAttachable } from "client/Forms/attachable";
import { ReactElement, useCallback } from "react";
import styles from "./ScopeCollection.module.less";
import { generateTrackingId, setTrackingId } from "client/Misc/utils";
import {
	IconButton,
	InputRow,
	TextInput,
	ValidationError
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";

export type ScopeCollectionProps = {
	attachable: IValueInputAttachable<readonly string[]>;
	maxCount: number;
};

export const ScopeCollection = (props: ScopeCollectionProps): ReactElement => {
	const {
		attachable,
		maxCount
	} = props;

	const addHandler = useCallback(
		(): void => {
			attachable.reducer
				.push("");

			attachable.validation
				.triggerInputFinished();
		},
		[attachable.reducer, attachable.validation]
	);

	const removeHandler = useCallback(
		(index: number): void => {
			attachable
				.reducer
				.removeAt(index);

			attachable.validation
				.triggerInputFinished();
		},
		[
			attachable.reducer,
			attachable.validation
		]
	);

	return (
		<div
			{...setTrackingId(attachable.reducer.path)}
			className={styles.root}
		>
			<ul className={styles.list}>
				{attachable.map((x, i): ReactElement => (
					<li key={i}>
						<Item
							attachable={x}
							onRemove={() => removeHandler(i)}
						/>
					</li>
				))}
			</ul>

			{attachable.value.length < maxCount && (
				<IconButton
					kind="dashed"
					width="fill"
					icon="plus"
					onClick={addHandler}
					trackingId="add"
				/>
			)}
		</div>
	);
};
ScopeCollection.displayName = "ScopeCollection";

type ItemProps = {
	attachable: IValueInputAttachable<string>;
	onRemove(): void;
};

const Item = (props: ItemProps): ReactElement => {
	const {
		attachable,
		onRemove
	} = props;

	return (
		<>
			<InputRow>
				<InputRow.Stretch>
					<TextInput
						{...attachable.attachToTextInput()}
						placeholder={localize("_EnterScope")}
					/>
				</InputRow.Stretch>
				<IconButton
					kind="secondary"
					icon="minus"
					onClick={onRemove}
					trackingId={generateTrackingId(attachable.reducer.path, "_remove")}
				/>
			</InputRow>
			<ValidationError {...attachable.attachToValidationError()} />
		</>
	);
};
Item.displayName = "Item";